export enum AlarmStatus {
  ACTIVE = 'active',
  ACKNOWLEDGED = 'acknowledged',
  RESOLVED = 'resolved',
}

export enum AlarmSeverity {
  INFO = 'info',
  WARNING = 'warning',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export enum AlarmType {
  LOW_BATTERY = 'low_battery',
  LEAK = 'leak',
  DRY = 'dry',
  REVERSE_FLOW = 'reverse_flow',
  NO_DATA = 'no_data',
  MANIPULATION = 'manipulation',
  OFFLINE = 'offline',
}

export enum AlarmOperator {
  LT = 'lt',
  LTE = 'lte',
  GT = 'gt',
  GTE = 'gte',
  EQ = 'eq',
  NEQ = 'neq',
  BETWEEN = 'between',
  OUTSIDE = 'outside',
  NO_DATA = 'no_data',
}
